/*
 *  Class Header
 */
export
default class Header {
    constructor() {
      this.searchButton = document.getElementById('js-search-btn');
      this.searchFormOverlay = document.getElementById('js-search-form-overlay');

      /** @type {HTMLInputElement} */
      this.searchInput = document.getElementById('js-search-input');

      this.searchForm = document.getElementById('js-search-form');
      this.searchClear = document.getElementById('js-search-clear');

      /** @type {HTMLDivElement} */
      this.searchFormatError = document.getElementById('js-search-error--format');

      /** @type {HTMLDivElement} */
      this.searchLengthError = document.getElementById('js-search-error--min');
    }

    init() {
      const submenus = document.querySelectorAll('.header-mobile-submenu');

      if (submenus) {
        for (let submenu of submenus) {
          const submenuTrigger = submenu.closest('li').querySelector('a');
          const submenuClose = submenu.querySelector('.header-mobile-submenu-closeBtn');
          if (submenuTrigger || submenuClose) {
            submenuTrigger.addEventListener('click', this.toggleMenu.bind(this));
            submenuClose.addEventListener('click', this.toggleMenu.bind(this));
          }
        }
      }

      this.bindEvent();
      this.bindTracking();
    }

    toggleMenu (event) {
      console.log('<'+event.target.nodeName+'>'+' triggered');
      event.preventDefault();
      // Submenu node
      if (event.target.nodeName == 'A' || event.target.nodeName == 'SPAN') { // span => screen-reader-class, a => label
        const submenu = event.target.closest('li').querySelector('.header-mobile-submenu');
        if (submenu) {
          submenu.classList.toggle('open');
        }
      } else if (event.target.nodeName == 'DIV') { // DIV => back button
        const menuToOpen = this.getParentByClassName(event.target, '.header-mobile-submenu');
        const menuToClose = event.target.parentElement;

        menuToClose.classList.toggle('open');
        // this case fails when no parent submenu is present, then it should skip
        if (menuToOpen && menuToOpen != null) {
          menuToOpen.classList.toggle('open');
        }
      }
    }

    /// <sumary>Traverses to the first parent with the given class name and returns the element.</sumary>
    /// <param name='context'>To starting node</param>
    /// <param name='className'>The class which is looked for</param>
    /// <returns>First ancestor with given class name or null</returns>
    getParentByClassName (context, className) {
      while (context.className != className) {
        if (context.parentElement) {
          context = context.parentElement;
        } else {
          return null;
        }
      }
    }

    toggleSearchOverlay() {
      this.searchFormOverlay.classList.toggle('active');
      this.searchButton.classList.toggle('active');
    }

    onSearchFormSubmit(event) {
      event.preventDefault();

      // form validation
      this.searchFormatError.classList.remove('active');
      this.searchLengthError.classList.remove('active');

      if (!this.searchInput.validity.valid) {
        if (this.searchInput.validity.tooShort) {
            this.searchLengthError.classList.add('active');
        } else {
            this.searchFormatError.classList.add('active');
        }

        return;
      }

      const urlParams = new URLSearchParams(window.location.search);
      const searchword = this.searchInput.value;
      const productUrl = this.searchFormOverlay.dataset.productPageUrl;
      urlParams.set('searchword', searchword);
      window.location.href = `${window.location.origin}/${productUrl}?${urlParams}`;
    }

    onSearchInputChanges(event) {
      const { target } = event;
      if (target.value) {
        this.searchClear.classList.add('active');
      } else {
        this.searchClear.classList.remove('active');
      }
    }

    clearSearchInput() {
      this.searchInput.value = '';
      this.searchClear.classList.remove('active');
    }

    onClickOutSideSearchPanel(event) {
      const isSearchFormOverlay = this.searchFormOverlay.contains(event.target);
      const isSearchButton = this.searchButton.contains(event.target);
      if (!isSearchFormOverlay && !isSearchButton) {
        this.searchFormOverlay.classList.remove('active');
        this.searchButton.classList.remove('active');
      }
    }

    bindEvent() {
      if (this.searchButton && this.searchFormOverlay) {
        this.searchButton.addEventListener('click', this.toggleSearchOverlay.bind(this));
        this.searchInput.addEventListener('input', this.onSearchInputChanges.bind(this));
        this.searchForm.addEventListener('submit', this.onSearchFormSubmit.bind(this));
        this.searchClear.addEventListener('click', this.clearSearchInput.bind(this));
        document.addEventListener('click', this.onClickOutSideSearchPanel.bind(this));
      }
    }

    bindTracking() {
        const mainMenu = document.querySelector('.header__main-nav');
        const mobileMenu = document.querySelector('.header-mobile__nav');

        if (mainMenu) {
            const mainMenuFirstLevelLinks = mainMenu.querySelectorAll('a.menu-link');
            const mainMenuSecondLevelLinks = mainMenu.querySelectorAll('a.sub-menu-link');

            mainMenuFirstLevelLinks.forEach(link => {
                this.trackLink(link, '1');
            });

            mainMenuSecondLevelLinks.forEach(link => {
                this.trackLink(link, '2');
            });
        }

        if (mobileMenu) {
            const mobileMenuFirstLevelLinks = mobileMenu.querySelectorAll('.parent-menu-item a');
            const mobileMenuSecondLevelLinks = mobileMenu.querySelectorAll('.menu-item a');

            mobileMenuFirstLevelLinks.forEach(link => {
                this.trackLink(link, '1');
            });

            mobileMenuSecondLevelLinks.forEach(link => {
                this.trackLink(link, '2');
            });
        }
    }

    trackLink(link, level) {
        level = level || '1';

        link.addEventListener('click', () => {

					const textContent = (link.textContent ||  link.getAttribute('title') || '').replace(/\s+/g,' ').trim();

            const url = new URL(link.href);

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ event_parameter: null });
            window.dataLayer.push({
                event: 'custom_event',
                event_name: 'menu_interaction',
                event_parameter: {
                    action: 'click',
                    element_type: 'header menu',
                    page_section: 'header',
                    navigation_level: level, // "1"
                    click_text: textContent, // "Mobilgeräte" {page-title}
                    link_url: link.href, // "https://www.mobilezone.ch/de/mobilgeraete"
                    page_location: url.origin

                }
            });
        });
    }
}
